export const RESIDENCY_OPTIONS = [
  { value: "US Citizen", label: "US Citizen" },
  { value: "Non-US", label: "Non-US" },
];

export const BOOKKEEPING_METHOD_OPTIONS = [
  { value: "CASH", label: "Cash" },
  { value: "ACCRUAL", label: "Accrual" },
];

export const OTHER_DOCS_IN_HAND = "Other";

export const DOCS_IN_HAND_OPTIONS = [
  { value: "EIN", label: "EIN" },
  { value: "DE Franchise Tax", label: "DE Franchise Tax" },
  {
    value: "Certificate of Incorporation",
    label: "Certificate of Incorporation",
  },
  { value: "Cap Table", label: "Cap Table" },
  { value: OTHER_DOCS_IN_HAND, label: "Other" },
];
